module.exports = __webpack_public_path__ + "media/mypage/images/icons/sp_map-58116d49866210b71516452ed978ebc1.svg";